export default __webpack_public_path__ + "static/Seminar-6509303b3eb667cd5be517cff323894b.jpeg";